module.exports = __webpack_public_path__ + "img/1.0f27e74f.jpg";